import Vue from 'vue';
import App from './App.vue';
// import router from './router';
import store from './store';
import { Dialog, Button, Icon, Popup, Tabbar, TabbarItem } from 'vant';
import server from './server/index';
import pay from './server/pay';
import { sendGoods } from '@/api/mixServer';

import './assets/css/init.scss';
// import Vant from 'vant';
// var Vconsole = require('vconsole');
// var vconsole = new Vconsole();
Vue.use(Dialog);
Vue.use(Button);
Vue.use(Icon);
Vue.use(Popup);
Vue.use(Tabbar);
Vue.use(TabbarItem);
// Vue.use(Vant);
server.gameReady();
// 2021.12.9游戏声明先弹窗再进行初始化
// server.init()
pay.init();
Vue.config.productionTip = false;

// window挂载ios回调方法后通知发货
window.payCallBack = function(data) {
  const sendParams = {
    order_id: data.order_id,
    receipt: data.receipt
  };
  sendGoods(sendParams).then(({ ret, msg }) => {
    let sendData = [data.order_id, ret];
    try {
      window.webkit.messageHandlers['sendBackData'].postMessage({params: sendData})
    } catch(err) {
      console.log('浏览器不支持苹果支付',err)
    }
    if (ret == 0) {
      console.log('发货成功')
    } else {
      Dialog({ message:  msg });
    }
  })
}
new Vue({
  // router,
  store,
  render: h => h(App)
}).$mount('#app');
